import ContentNavbar from "components/ContentNavbar";
import Footer from "components/Footer";
import { contentNavData } from "constant/ContentNavBarData";
import GridCardsSection from "pages/welcome/GridCardSection";
import MusicCarousel from "pages/welcome/MusicCarousel";
import TrendMovies from "pages/welcome/TrendMovies";
import WelcomePageSidebar from "pages/welcome/WelcomePageSidebar";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import TVChannelSection from "./welcome/TVChannelSection";
import WelcomePagePodcast from "./welcome/WelcomePagePodcast";
import WelcomeTVSeries from "./welcome/WelcomeTVSeries";
import LikeService from "services/music/LikeService";
import HeroBanner from "pages/liveTvPage/home/HeroBanner";
import WelcomePageRadioSection from "./welcome/WelcomePageRadioSection";
import WelcomePageDiscoverPlaylists from "./welcome/shared/WelcomePageDiscoverPlaylists";
import { Helmet } from "react-helmet-async";
import ayozatProps from "Assets/Images/ayozat_prop.svg";

import { Adsense } from "@ctrl/react-adsense";
import WelcomePagePayperview from "./welcome/WelcomePagePayperview";
import WelcomePageCreatorVideoSection from "./welcome/WelcomePageCreatorVideoSection";
import PopUpModel from "components/PopUpModel";
import TermsPopUp from "components/TermsPopUp";
import TermsPopUpModel from "components/TermsPopUpModel";
import GeneralServices from "services/General/GeneralServices";
import WelcomePageCreatorArtist from "./welcome/WelcomePageCreatorArtist";
import { Link } from "react-router-dom";

function Welcome({
  handleClick,
  isActive,
  setIsActive,
  // setPlayerIsActive,
  anyPlayerActive,
}: // user chat dat

any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [favoriteMovies, setFavoriteMovies] = useState<any>();
  const [favoriteTvSeries, setFavoriteTvSeries] = useState<any>();
  const FE_URL = process.env.REACT_APP_FRONTEND_URL;
  const adContainerRef = useRef<HTMLDivElement | null>(null);
  const [gAdSlot, setgAdSlot] = useState<any>();
  const [subscriptionEnabled, setSubscriptionEnabled] = useState<any>();
  const enabled = localStorage.getItem("ppv_enabled");
  const [termsValue, setTermsValue] = useState(() => {
    const storedValue = localStorage.getItem("terms_value");
    return storedValue !== null ? storedValue : "0";
  });

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    GeneralServices.getAllConfigData()
      .then((res) => {
        const PageStatus = res?.data?.filter(
          (item: any) => item?.title === "is_home_gAd" && item?.value !== null,
        );
        if (PageStatus?.[0]?.value === "1") {
          const filteredData = res?.data?.filter(
            (item: any) => item?.title === "gAdSlot" && item?.value !== null,
          );
          setgAdSlot(filteredData?.[0]?.value);
        }
        const SubsStatus = res?.data?.filter(
          (item: any) =>
            item?.title === "subscription_enabled" && item?.value !== null,
        );
        if (SubsStatus?.[0]?.value === "1") {
          setSubscriptionEnabled(SubsStatus[0]?.value);
        }
      })
      .catch((e) => {});
  }, []);

  //show model
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (termsValue === "0") {
      openModal();
    }
  }, []);

  const isActiveTermsPopUp = () => {
    setTermsValue("1");
    localStorage.setItem("terms_value", "1");
    closeModal();
  };

  useEffect(() => {
    // setIsLoding(true);
    if (loggedInUser) {
      LikeService.getFavoriteById(loggedInUser?.id, loggedInUser?.id)
        .then((res) => {
          // setIsLoding(false);
          const favoritesMoviesIds = res?.profile?.favorite_movies?.map(
            (item: any) => item.id,
          );
          const favoritesTvSeriesIds = res?.profile?.favorite_tv_series?.map(
            (item: any) => item.id,
          );
          setFavoriteMovies(favoritesMoviesIds);
          setFavoriteTvSeries(favoritesTvSeriesIds);
        })
        .catch(() => {});
    }
  }, [loggedInUser]);

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based
  const day = String(today.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  const created_date = loggedInUser?.created_at?.toString().split("T")[0];

  return (
    <>
      <Helmet>
        <title>
          Watch AYOZAT – Streaming Movies, Series, Live TV, Music, Radio &
          Podcasts plus Live Pay-Per-View Events.
        </title>
        <meta
          name="description"
          content="Stream Movies, Series, Live TV, Music, Radio & Podcasts plus Live Pay-Per-View Events. Watch on AYOZAT STREAM. Your Entertainment Hub!"
        />
        <link rel="canonical" href={FE_URL} />
        <meta
          property="og:title"
          content="Watch AYOZAT – Streaming Movies, Series, Live TV, Music, Radio & Podcasts plus Live Pay-Per-View Events."
        />
        <meta
          property="og:description"
          content="Stream Movies, Series, Live TV, Music, Radio & Podcasts plus Live Pay-Per-View Events. Watch on AYOZAT STREAM. Your Entertainment Hub!"
        />
        <meta property="og:image" content="https://ayozat.co.uk/logo192.png" />
        <meta property="og:type" content="website" />
        <meta name="og:url" content={`${FE_URL}`} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Watch AYOZAT – Streaming Movies, Series, Live TV, Music, Radio & Podcasts plus Live Pay-Per-View Events."
        />
        <meta
          name="twitter:description"
          content="Stream Movies, Series, Live TV, Music, Radio & Podcasts plus Live Pay-Per-View Events. Watch on AYOZAT STREAM. Your Entertainment Hub!"
        />
        <meta name="twitter:image" content="https://ayozat.co.uk/logo192.png" />
        <meta name="twitter:site" content="AYOZAT STREAM" />
        <meta name="twitter:url" content={`${FE_URL}`} />
      </Helmet>

      <div className={`${anyPlayerActive ? `mb-[140px]` : `mb-30`}`}>
        <ContentNavbar handleClick={handleClick} isActive={isActive} />

        <WelcomePageSidebar
          isActive={isActive}
          navData={contentNavData}
          setIsActive={setIsActive}
        />
        <div
          className={
            isActive
              ? "pl-[80px] duration-500 p-2 mt-2 ml-4 max-sm:pl-0 max-sm:ml-2 "
              : "pl-0 duration-500 p-2 mt-2 ml-8 max-sm:pl-0 max-sm:ml-2 "
          }
        >
          <div className="ml-3">
            {/* Compact greeting above the cinematic hero */}
            <div className="mb-5 cursor-default">
              {loggedInUser ? (
                formattedDate === created_date ? (
                  <p className="font-rubik text-xl font-medium text-white/90 md:text-2xl">
                    Welcome{" "}
                    <span className="bg-gradient-to-r from-[#f30543] to-[#ff6b6b] bg-clip-text font-semibold text-transparent">
                      {loggedInUser?.username}
                    </span>{" "}
                    to AYOZAT
                  </p>
                ) : (
                  <p className="font-rubik text-xl font-medium text-white/90 md:text-2xl">
                    Welcome back{" "}
                    <span className="bg-gradient-to-r from-[#f30543] to-[#ff6b6b] bg-clip-text font-semibold text-transparent">
                      {loggedInUser?.username}
                    </span>
                  </p>
                )
              ) : (
                <p className="font-rubik text-xl font-medium text-white/90 md:text-2xl">
                  Welcome to{" "}
                  <span className="bg-gradient-to-r from-[#f30543] to-[#ff6b6b] bg-clip-text font-semibold text-transparent">
                    AYOZAT
                  </span>
                </p>
              )}
            </div>
            <HeroBanner />
            {gAdSlot && (
              <Adsense
                client="ca-pub-5773929890067376"
                slot={gAdSlot}
                style={{
                  display: "flex",
                  marginBottom: "30px",
                  height: "90px",
                  justifyContent: "center",
                }}
                format="horizontal"
                data-full-width-responsive="true"
              />
            )}
            <TVChannelSection />
            <TrendMovies favorite={favoriteMovies} />
            <WelcomeTVSeries favorite={favoriteTvSeries} />
            <WelcomePageCreatorArtist />
            <WelcomePageCreatorVideoSection />
            {gAdSlot && (
              <Adsense
                client="ca-pub-5773929890067376"
                slot={gAdSlot}
                style={{
                  display: "flex",
                  marginBottom: "30px",
                  height: "90px",
                  justifyContent: "center",
                }}
                format="horizontal"
                data-full-width-responsive="true"
              />
            )}
            <MusicCarousel user={loggedInUser} />
            <WelcomePagePodcast />
            <WelcomePageRadioSection text="Live Radio Channels" />
            {enabled === "1" && <WelcomePagePayperview />}
            <WelcomePageDiscoverPlaylists welcomePage={true} />
            {gAdSlot && (
              <Adsense
                client="ca-pub-5773929890067376"
                slot={gAdSlot}
                style={{
                  display: "flex",
                  marginBottom: "30px",
                  height: "90px",
                  justifyContent: "center",
                }}
                format="horizontal"
                data-full-width-responsive="true"
              />
            )}

            {subscriptionEnabled === "1" && (
              <div className="relative my-12 flex flex-col items-center justify-center overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.05] to-transparent px-6 py-12 text-center">
                {/* ambient glow */}
                <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[600px] max-w-full -translate-x-1/2 rounded-full bg-[var(--red)] opacity-10 blur-[120px]" />

                <h2 className="font-Plus-Jakarta-Sans text-[40px] font-[800] leading-tight tracking-tight text-white max-sm:text-[22px]">
                  Explore{" "}
                  <span className="bg-gradient-to-r from-[#f30543] to-[#ff6b6b] bg-clip-text text-transparent">
                    AYOZAT Premium
                  </span>{" "}
                  Plans
                </h2>
                <p className="font-Plus-Jakarta-Sans mt-4 max-w-2xl text-[16px] font-[400] leading-[26px] text-white/70 max-sm:text-[12px]">
                  Unlock a world of entertainment with our premium subscription
                  plans. Enjoy exclusive content, ad-free streaming, and
                  enhanced features for an unparalleled viewing experience.
                </p>
                <img
                  src={ayozatProps}
                  alt="ayozat figure"
                  className="mx-auto -mt-12 block max-sm:mt-0"
                />

                <div className="mx-auto -mt-24 flex w-[300px] flex-col items-center justify-center max-sm:-mt-4">
                  <p className="font-Plus-Jakarta-Sans text-center text-[28px] font-[800] leading-none text-white">
                    $99.90
                    <span className="text-[22px] font-normal text-white/60">
                      {" "}
                      / month
                    </span>
                  </p>

                  <Link to="/subscription/plan">
                    <button className="mt-5 flex h-[44px] items-center justify-center rounded-full border border-white/30 px-7 py-3 text-center font-Plus-Jakarta-Sans font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-[#f30543] hover:bg-[#f30543] hover:text-white hover:shadow-lg hover:shadow-[#f30543]/30">
                      Explore More Plans
                    </button>
                  </Link>
                </div>
              </div>
            )}
            <GridCardsSection />
          </div>
        </div>
        <Footer />
      </div>
      {showModal && (
        <div className="z-50">
          <TermsPopUpModel
            isOpen={showModal}
            onClose={closeModal}
            width={"800px"}
          >
            <TermsPopUp onClose={isActiveTermsPopUp} />
          </TermsPopUpModel>
        </div>
      )}
    </>
  );
}

export default Welcome;
